<template>
  <artisio-modal size="lg" :visible="shippingModal.show" :data="object"
                 @hidden="onHidden" :content-in-form="false"
                 :show-confirmation="false" :is-loading="loading"
                 :hideFooter="true" body-class=""
                 scrollable :title="title" modal-class="mobile-full-screen">
    <div class="row" v-if="computedInvoice">
      <div class="col-md-12 d-flex align-items-center" v-if="computedInvoice.customer">
        <div>
          <h5 class="mb-0">
            <router-link tabindex="-1"
                         :to="{ name: 'customers.dashboard', params: { id: computedInvoice.customer.uuid }}">
              {{ computedInvoice.customer.display_name }}
            </router-link>
          </h5>
          <p class="mb-0" v-if="computedInvoice.customer.billing_address"
             v-html="$options.filters.asAddress(computedInvoice.customer.billing_address, false)">
          </p>
        </div>
        <b-button @click="onExportClick" variant="primary" class="ml-auto">{{ $t('Export') }}</b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <artisio-table :items="computedItems" :fields="tableFields"
                       :index="false" :selectable="false"
                       :enableSimpleSearch="false">
          <template slot="cell(stock)" slot-scope="{item: item}">
            <router-link v-if="$hasPermission('view_receipt')"
                         :to="{name: 'receipt.view', params: {id: item.inventory.receipt_uuid}}">
              {{ item.inventory.stock_no.split('/')[0] }}
            </router-link>
            /
            <router-link v-if="$hasPermission('view_inventoryitem')"
                         :to="{ name: 'inventory.view', params: { id: item.inventory.uuid }}">
              {{ item.inventory.stock_no.split('/')[1] }}
            </router-link>
          </template>
          <template slot="cell(title)" slot-scope="{item: item}">
            <router-link v-if="$hasPermission('view_inventoryitem')"
                         :to="{ name: 'inventory.view', params: { id: item.inventory.uuid }}">
              {{ item.inventory.short_description  | striptags }}
            </router-link>
          </template>
          <template slot="cell(lot)" slot-scope="{item: item}">
            {{ item.lot ? item.lot.lot_no : '' }}
          </template>
          <template slot="cell(quantity)" slot-scope="{item: item}">
            {{ item.lot ? item.lot.quantity : item.quantity }}
          </template>
          <template slot="cell(item_location)" slot-scope="{item: item}">
            {{ item.inventory.item_location.name }}
          </template>
          <template slot="cell(collection_address)" slot-scope="{item: item}">
            {{ item.inventory.collection_info_full }}
          </template>
          <template slot="cell(collection_date)" slot-scope="{item: item}">
            <template v-if="item.lot">
              {{ item.lot.reservation.collected_at | toDateTime }}
            </template>
          </template>
        </artisio-table>
      </div>
    </div>
  </artisio-modal>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import i18n from "@/shared/i18n";
  import ArtisioTable from "@/core/components/ams-table/ArtisioTable";
  import {INVOICE_TYPE_AUCTION} from "@/modules/constants";
  import ExportsService from "@/core/services/exports.service";

  const {mapState, mapActions} = createNamespacedHelpers('invoices');

  export default {
    name: "ShippingModal",
    components: {ArtisioModal, ArtisioTable},
    data() {
      return {
        loading: false,
        tableFields: [
          {key: "stock", label: i18n.t('Stock'), sortable: false},
          {key: "lot", label: i18n.t('Lot'), sortable: false},
          {key: "title", label: i18n.t('Title'), sortable: false},
          {key: "quantity", label: i18n.t('Quantity'), sortable: false},
          {key: "item_location", label: i18n.t('Item Location'), sortable: false},
          {key: "collection_address", label: i18n.t('Collection Address'), sortable: false},
          {key: "collection_date", label: i18n.t('Collection Date'), sortable: false},
        ],
        title: i18n.t('View Details')
      }
    },
    computed: {
      ...mapState({
        shippingModal: state => state.shippingModal,
        object: state => state.shippingModal.object
      }),
      computedItems() {
        if (this.computedInvoice && this.computedFinancialItems) {
          if (this.computedInvoice.type === INVOICE_TYPE_AUCTION) {
            return this.computedFinancialItems.map((i) => {
              return {lot: i.lot, inventory: i.lot.reservation.inventory}
            })
          } else {
            return this.computedFinancialItems.map((i) => {
              return {quantity: i.quantity, inventory: i.inventory}
            })
          }
        }
        return []
      },
      computedInvoice() {
        return this.object && this.object.is_credit_note ? this.object.credited_invoice : this.object;
      },
      computedFinancialItems() {
        if (this.isCreditNote) {
          return this.computedInvoice.credited_financial_items;
        } else {
          if (['cancelled'].includes(this.computedInvoice.status)) {
            return this.computedInvoice.cancelled_financial_items;
          }
          return this.computedInvoice.financial_items;
        }
      },
      isCreditNote() {
        return this.object && (this.object.is_credited || this.object.is_credit_note);
      },
    },
    methods: {
      ...mapActions(['hideShippingModal']),
      onHidden() {
        this.hideShippingModal();
      },
      async onExportClick() {
        let response = await ExportsService.generateToken();
        if (!response.success) {
          return false;
        }
        let params = {
          token: response.body.token
        }
        window.open(
            ExportsService.prepareExportUrl(`/api/v1/invoices/${this.object.uuid}/export-details`, params),
            '_blank'
        );
      }
    }
  }
</script>

<style scoped>
  /deep/ .artisio-table table tbody tr td {
    padding: 0.5rem;
  }
</style>
